// 业务路由page需要对应的问价夹名字或者简写，避免重复，路由名字采用驼峰规则书写
const routes = [
  {
    path: "/massMessageIndex",
    name: "massMessageIndex",
    component: () => import("../Index.vue"),
    meta: {
      title: "金融行业群发机器人",
      keepAlive: false
    }
  },
  {
    path: "/massMessageSendResult/:id?",
    name: "sendResult",
    component: () => import("../sendResult.vue"),
    meta: {
      title: "金融行业群发机器人",
      keepAlive: false
    }
  }
];

export default routes;
